import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  enableDescription?: boolean;
  forAdminUse?: boolean;
}

const RequirementSimplifiedHeader = ({ enableDescription = false, forAdminUse = false }: Props) => {
  // translations
  const tLabels = useTranslation("requirements\\requirements").t;

  return (
    <div className="d-none d-sm-block mb-2 text-muted font-weight-bold">
      <div className="row no-gutters align-items-center px-3 mr-5">
        <div className="col-auto col-sm-3 col-lg-2 pr-2">
          {tLabels("requirementSimplifiedHeader.date")}
        </div>
        <div className="col-auto col-sm-3 col-lg-2 pr-sm-2 text-truncate">
          {tLabels("requirementSimplifiedHeader.number")}
        </div>
        <RenderWrapper isVisible={() => forAdminUse}>
          <div className="col-auto col-sm-3 col-lg-2 pr-sm-2 text-truncate">
            {tLabels("requirementSimplifiedHeader.customer")}
          </div>
        </RenderWrapper>
        <div className={forAdminUse ? "col-sm-3 col-lg-6" : "col-sm-6 col-lg-8"}>
          <div className="row no-gutters align-items-center">
            <RenderWrapper isVisible={() => forAdminUse}>
              <div className={`d-none d-lg-block col-lg-4${enableDescription ? " col-xl-2" : ""}`}>
                {tLabels("requirementSimplifiedHeader.category")}
              </div>
            </RenderWrapper>
            <div className={
              forAdminUse
                ? `col-auto px-lg-3 col-lg-4${enableDescription ? " col-xl-3" : ""}`
                : `col-auto px-lg-3 col-lg-6${enableDescription ? " col-xl-4" : ""}`
            }>
              {tLabels("requirementSimplifiedHeader.type")}
            </div>
            <div className="col-auto d-lg-none">/</div>
            <div className={
              forAdminUse
                ? `col-auto col-lg-4${enableDescription ? " col-xl-3" : ""}`
                : `col-auto col-lg-6${enableDescription ? " col-xl-3" : ""}`
            }>
              {tLabels("requirementSimplifiedHeader.state")}
            </div>
            <RenderWrapper isVisible={() => enableDescription}>
              <div className={`d-none d-xl-block pl-lg-4${forAdminUse ? " col-xl-4" : " col-xl-5"}`}>
                {tLabels("requirementSimplifiedHeader.description")}
              </div>
            </RenderWrapper>
          </div>
        </div>
      </div>
    </div>
  )
}

export default RequirementSimplifiedHeader;
